const maxWidth = (theme, { breakpoints }) => ({
  16: "4rem",
  32: "8rem",
  40: "10rem",
  44: "11rem",
  48: "12rem",
  52: "13rem",
  56: "14rem",
  max: "max-content",
  fit: "fit-content",
  full: "100%",
  xs: "20rem",
  sm: "24rem",
  md: "28rem",
  lg: "32rem",
  xl: "36rem",
  "2xl": "42rem",
  "3xl": "48rem",
  "4xl": "56rem",
  "5xl": "64rem",
  "6xl": "72rem",
  "7xl": "80rem",
  ...breakpoints(theme("screens")),
})

module.exports = {
  maxWidth,
}

exports.default = maxWidth
